<template>
    <CContainer>
      <CRow :class="$style['row']">
        <CCol sm="12" style="min-width: 300px; margin: 0 10px;padding:0" v-for="(option, index) in options" :key="index">
          <CRow>
            <CCol md="9" :class="$style['condiments']">
              <v-checkbox
                :key="index"
                color="primary"
                :value="option[valueKey]"
                v-model="localValue"
                :name="name"
                :readonly="readonly"
                :disabled="disabled"
                :data-vv-as="label"
                @change="onChange"
                :hide-details="true"
              >
                <div slot="label" :class="$style['label']">
                  <span :class="$style['text']">
                    <span v-if="option['publish']">
                <CBadge class="ma-2" color="success"  x-small label
                style="margin-top: 0;margin-bottom: 0;"
                >公開</CBadge>
              </span>
                    <span v-else-if="option['publish'] !== undefined">
                <CBadge class="ma-2" color="warning"  x-small label
                        style="margin-top: 0;margin-bottom: 0;"
                >非公開</CBadge>
              </span>
                    <strong>{{ option[textKey] }}</strong>
                  </span>
                </div>
              </v-checkbox>
            </CCol>
            <CCol md="3" style="padding: 5px">
              <CInputRadio
                      v-if="localValue"
                      style="margin-top: 5px"
                      :checked="option[valueKey] === localValue[0]"
                @update:checked="onChecked(option[valueKey])"
                      label="メイン"
              >
              </CInputRadio>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CContainer>
</template>

<script>
export default {
  props: {
    value: {},
    defaultValue: {
      type: Array,
    default: () => {return []}
    },
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      required: true
    },
    valueKey: {
      type: String,
      required: true
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    },
    onchange: {
      default: () => {}
    },
    remarks: {
      type: String,
      default: ""
    }
  },
  watch: {
    options(value) {
      this.localValue = this.defaultValue; // これでチェックボックスも初期化される
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value != null &&
          this.value[0] != null &&
          Object.prototype.toString.call(this.value[0]) === "[object Object]"
          ? this.value.map(val => {
              return val[this.valueKey];
            })
          : this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onChange(value){
    },
    onChecked(value){
      const index = this.localValue.indexOf(value);
      this.moveAt(this.localValue, index, 0);
    },
    moveAt(array, index, at) {
      if (index === at || index > array.length -1 || at > array.length - 1) {
        return array;
      }

      const value = array[index];
      const tail = array.slice(index + 1);

      array.splice(index);

      Array.prototype.push.apply(array, tail);

      array.splice(at, 0, value);

      return array;
    }
  }
};
</script>

<style module lang="scss">
.description {
  margin: 0;
}
.label {
  display: flex;
  align-content: center;
}
.image__radio {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.text {
  display: flex;
  align-items: center;
}
.remarks {
  font-size: 12px;
  &:before {
    content: "※";
    margin-right: 4px;
  }
}

.condiments{
  padding: 0 5px;
}

.row {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<style lang="scss">
  .v-input__slot{
    margin: 0;
  }
  </style>
